import { mutations } from './mutations';
import { state } from './state';
import { getters } from './getters';
import { actions } from './actions';

import kvk from './apis/kvk';
import brk from './apis/brk';
import brp from './apis/brp';
import stuf from './apis/stuf';
import woz from './apis/woz';

const store = {
    state: { ...state, ...kvk.state, ...brk.state, ...brp.state, ...stuf.state, ...woz.state },

    mutations: { ...mutations, ...kvk.mutations, ...brk.mutations, ...brp.mutations, ...stuf.mutations, ...woz.mutations },

    actions: { ...actions, ...kvk.actions, ...brk.actions, ...brp.actions, ...stuf.actions, ...woz.actions },

    getters: { ...getters, ...kvk.getters, ...brk.getters, ...brp.getters, ...stuf.getters, ...woz.getters }
};

export default store;
